<template>
  <el-row :gutter="16">
    <el-col :span="24">
      <div class="moduleStyle mb16 plr24">
        <div class="moduleStyle_title">
          <h3 class="workbench-title">
            {{shopName}}业务数据<span></span
            >
          </h3>
          <div>
            <!-- <el-button
              type="primary"
              size="small"
              icon="el-icon-refresh-left"
              @click="updateTotalCapital()"
              >更新总资本</el-button
            > -->
            <el-button
              type="primary"
              size="small"
              icon="el-icon-refresh-left"
              @click="getlist()"
              >刷新</el-button
            >
          </div>
        </div>
        <!-- 采购数据汇总 -->
        <div class="procurementDataSummary workbenchSummary">
          <ul>
            <li>
              <div class="summaryTitle">
                今日销售
              </div>
              <div class="today summaryLine">
                <p>{{ summarizeData.daily_total_sell | money }}</p>
              </div>
            </li>

            <li>
              <div class="summaryTitle">
                今日采购
              </div>
              <div class="today summaryLine">
                <p>{{ summarizeData.daily_total_buy | money}}</p>
              </div>
            </li>

            <li>
              <div class="summaryTitle">
                当日毛利
              </div>
              <div class="summaryLine">
                <p>
                  {{ summarizeData.daily_money_JY+summarizeData.today_other_get_pay | money}}
                </p>
              </div>
            </li>

            <li>
              <div class="summaryTitle">
                经营净毛利
              </div>
              <div class="summaryLine">
                <p>
                  {{ summarizeData.daily_money_JY | money}}
                </p>
              </div>
            </li>

            <li>
              <div class="summaryTitle">常规品毛利</div>
              <div class="summaryLine">
                <p>{{ summarizeData.daily_money_def_not_smoke | money}}</p>
              </div>
            </li>
            <li>
              <div class="summaryTitle">烟毛利</div>
              <div class="summaryLine">
                <p>{{ summarizeData.daily_money_def_smoke | money}}</p>
              </div>
            </li>

            <li>
              <div class="summaryTitle">
                其它收益
              </div>
              <div class="summaryLine">
                <p>
                  {{
                    parseFloat(
                      summarizeData.today_other_get_pay | money
                    ).toFixed(2)
                  }}
                </p>
              </div>
            </li>
            <li>
              <div class="summaryTitle">
                应收总金额
              </div>
              <div class="summaryLine">
                <p>
                  {{
                    parseFloat(
                      summarizeData.daily_shoud_get | money
                    ).toFixed(2)
                  }}
                </p>
              </div>
            </li>
            <li>
              <div class="summaryTitle">
                应付总金额
              </div>
              <div class="summaryLine">
                <p>
                  {{
                    parseFloat(
                      summarizeData.daily_shoud_pay | money
                    ).toFixed(2)
                  }}
                </p>
              </div>
            </li>
            <li>
              <div class="summaryTitle">
                临期商品数
              </div>
              <div class="summaryLine">
                <a href="index.html#/productShelfLife">
                <p style="color: #2E7FFF;">
                  {{
                     summarizeData.linqi_num
                  }}
                </p ></a >
              </div>
            </li>
          </ul>
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="moduleStyle mb16 plr24">
        <h3 class="workbench-title">门店指标</h3>
        <div class="table workbench_table">
          <el-table
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            :data="tradeData"
            style="width: 100%"
          >
            <el-table-column width="200" prop="name" label="门店名称" />
            <el-table-column width="150" prop="username" label="店长" />
            <el-table-column label="营业额" align="center">
              <el-table-column
                width="150"
                prop="turnover_trade"
                label="指标"
              />
              <el-table-column
                width="150"
                prop="totalrate"
                label="完成比例"
              >
              <template slot-scope="scope">
                {{ scope.row.totalrate=="-"?"-":scope.row.totalrate+"%" }}
              </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="订单量" align="center">
              <el-table-column
                width="150"
                prop="order_trade"
                label="指标"
              />
              <el-table-column
                width="150"
                prop="numrate"
                label="完成比例"
              >
              <template slot-scope="scope">
                {{ scope.row.numrate=="-"?"-":scope.row.numrate+"%" }}
              </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="动销数" align="center">
              <el-table-column
                width="150"
                prop="sales_trade"
                label="指标"
              />
              <el-table-column
                width="150"
                prop="salesrate"
                label="完成比例"
              >
              <template slot-scope="scope">
                {{ scope.row.salesrate=="-"?"-":scope.row.salesrate+"%" }}
              </template>
              </el-table-column>
            </el-table-column>
            <el-table-column label="毛利" align="center">
              <el-table-column
                width="150"
                prop="def_money_trade"
                label="指标"
              />
              <el-table-column
                width="150"
                prop="def_moneyrate"
                label="完成比例"
              >
              <template slot-scope="scope">
                {{ scope.row.def_moneyrate=="-"?"-":scope.row.def_moneyrate+"%" }}
              </template>
              </el-table-column>
            </el-table-column>
            <el-table-column width="150" prop="allrate" label="整体完成比例" >
              <template slot-scope="scope">
                {{ scope.row.allrate=="-"?"-":scope.row.allrate+"%" }}
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="moduleStyle mb16 plr24">
        <h3 class="workbench-title">本月销售绩效</h3>
        <div class="table workbench_table">
          <el-table
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            :data="tableData"
            style="width: 100%"
          >
            <el-table-column width="100" prop="name" label="员工" />
            <el-table-column width="150" prop="shopname" label="门店" />
            <el-table-column label="销售" align="center">
              <el-table-column
                width="100"
                prop="salecount"
                label="单数"
              />
              <el-table-column
                width="100"
                prop="countcustome1"
                label="客户数"
              />
              <el-table-column
                width="100"
                prop="real_profit_money1"
                label="毛利"
              />
              <el-table-column
                width="100"
                prop="num1"
                label="瓶数"
              />
              <el-table-column
                width="100"
                prop="profit_moneyrate1"
                label="毛利率"
              />
            </el-table-column>
            <el-table-column label="出库" align="center">
              <el-table-column
                width="100"
                prop="makecount"
                label="单数"
              />
              <el-table-column
                width="100"
                prop="countcustome2"
                label="客户数"
              />
              <el-table-column
                width="100"
                prop="real_profit_money2"
                label="毛利"
              />
              <el-table-column
                width="100"
                prop="num2"
                label="瓶数"
              />
              <el-table-column
                width="100"
                prop="profit_moneyrate2"
                label="毛利率"
              />
            </el-table-column>
            <el-table-column label="新增客户(30天)" align="center">
              <el-table-column
                width="100"
                prop="countcustome3"
                label="客户数"
              />
              <el-table-column
                width="100"
                prop="total_money3"
                label="金额"
              />
              <el-table-column
                width="100"
                prop="real_profit_money3"
                label="毛利"
              />
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
    <el-col :span="24">
      <div class="moduleStyle mb16 plr24">
        <h3 class="workbench-title">本月采购绩效</h3>
        <div class="table workbench_table">
          <el-table
            header-cell-class-name="headerCellStyle"
            cell-class-name="cellStyle"
            :data="tableData2"
            style="width: 100%"
          >
            <el-table-column prop="name" label="员工" />
            <el-table-column prop="shopname" label="门店" />
            <el-table-column label="采购" align="center">
              <el-table-column
                width="100"
                prop="countcustome1"
                label="单数"
              />
              <el-table-column
                width="100"
                prop="total_money1"
                label="金额"
              />
              <el-table-column
                width="100"
                prop="num1"
                label="瓶数"
              />
            </el-table-column>
            <el-table-column label="入库" align="center">
              <el-table-column
                width="100"
                prop="countcustome2"
                label="单数"
              />
              <el-table-column
                width="100"
                prop="total_money2"
                label="金额"
              />
              <el-table-column
                width="100"
                prop="num2"
                label="瓶数"
              />
            </el-table-column>
          </el-table>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import { userSellInfoEx, userSellInfo,userSellInfobymonth,getLinqi,getshoptradelist} from "@/api/basicConfiguration";
import { getRoles } from "@/utils";
export default {
  name: "employeeindex",
  data() {
    return {
      compId: null,
      userId: null,
      roleId: null,
      shopName:'',
      total_num: 0,
      summarizeData: {
        daily_total_sell:0,
        daily_total_buy:0,
        daily_money_JY:0,
        daily_money_def:0,
        daily_money_def_not_smoke:0,
        daily_money_def_smoke:0,
        daily_shoud_get:0,
        daily_shoud_pay:0,
        today_other_get_pay:0,
        linqi_num:0,
        },
      // 列表组件参数
      basicListconfig: {
        loading: false,
      },
      tableData: [],
      tableData2:[],
      tradeData:[],
      dialogVisible: false,
      updateDate: "",
    };
  },

  created() {
    console.log(this.$store.getters.userInfo);
    this.compId = this.$store.getters.userInfo.compId;
    this.userId = this.$store.getters.userInfo.userId;
    this.roleId = this.$store.getters.userInfo.roleId;
    setTimeout(() => {
       this.shopName=this.$store.getters.userInfo.userShops[0].name;
    },300)

    this.updateDate = this.$getCurrent(2);
    this.getlist(); // 先拿基础数据，在拉记录
  },

  methods: {
    confirmUpdate() {},
    // 更新总资产
    updateTotalCapital() {
      this.dialogVisible = true;
    },
    // 获取列表内容
    getlist() {
      this.basicListconfig.loading = true;
      getshoptradelist({shop_id:this.$store.getters.userInfo.shopId}).then((res) => {
        if (res.code == 1) {
           this.tradeData = res.list;
           console.log(this.tradeData);
        } else {
          this.$message.error(res.data.msg);
        }
      });
      userSellInfoEx().then((res) => {
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          //this.summarizeData=res.data;
          this.summarizeData.daily_total_sell= res.data.daily_total_sell;
          this.summarizeData.daily_total_buy= res.data.daily_total_buy;
          this.summarizeData.daily_money_JY= res.data.daily_money_JY;
          this.summarizeData.daily_money_def= res.data.daily_money_def;
          this.summarizeData.daily_money_def_not_smoke= res.data.daily_money_def_not_smoke;
          this.summarizeData.daily_money_def_smoke= res.data.daily_money_def_smoke;
          this.summarizeData.daily_shoud_get= res.data.daily_shoud_get;
          this.summarizeData.daily_shoud_pay= res.data.daily_shoud_pay;
          this.summarizeData.today_other_get_pay= res.data.today_other_get_pay;
          if (res.error_item > "") {
            this.$message.error("下列产品库存可能异常：" + res.error_item);
          }
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.msg);
        }
      });
      getLinqi({shop_id:this.$store.getters.userInfo.shopId}).then((res) => {
        if (res.code == 1) {
          this.summarizeData.linqi_num= res.count;
        } else {

          this.$message.error(res.data.msg);
        }
      });
     this.basicListconfig.loading = true;
      userSellInfobymonth().then((res) => {
       // console.log(res);
        if (res.code == 1) {
          this.basicListconfig.loading = false;
          this.tableData = res.list1;
          this.tableData2 = res.list2;
        } else {
          this.basicListconfig.loading = false;
          this.$message.error(res.data.msg);
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/employeeindex/index.vue